import { render, staticRenderFns } from "./HeaderLoginButton.vue?vue&type=template&id=aaa65748&scoped=true&"
import script from "./HeaderLoginButton.vue?vue&type=script&lang=js&"
export * from "./HeaderLoginButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa65748",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aaa65748')) {
      api.createRecord('aaa65748', component.options)
    } else {
      api.reload('aaa65748', component.options)
    }
    module.hot.accept("./HeaderLoginButton.vue?vue&type=template&id=aaa65748&scoped=true&", function () {
      api.rerender('aaa65748', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/HeaderLoginButton.vue"
export default component.exports